import React from 'react';

const Services = () => {
    return (
        <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-poppins font-bold text-aulanovus-blue mb-8 text-center">
          Nuestros Servicios
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Desarrollo de IA",
              description: "Soluciones personalizadas de inteligencia artificial para optimizar sus procesos empresariales.",
              icon: "🤖"
            },
            {
              title: "Integración de Soluciones",
              description: "Implementación perfecta de soluciones de IA en su infraestructura existente.",
              icon: "🔄"
            },
            {
              title: "Consultoría",
              description: "Asesoramiento experto en estrategias de IA y transformación digital.",
              icon: "💡"
            },
            {
              title: "Soporte Técnico",
              description: "Asistencia continua y mantenimiento para sus sistemas de IA.",
              icon: "🛠"
            },
            {
              title: "Análisis de Datos",
              description: "Procesamiento y análisis avanzado de datos para obtener insights valiosos.",
              icon: "📊"
            },
            {
              title: "Automatización",
              description: "Automatización de procesos mediante IA para aumentar la eficiencia.",
              icon: "⚙️"
            }
          ].map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100"
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-poppins font-semibold text-aulanovus-blue mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 font-inter">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
};

export default Services;